// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__Drlu5","container":"styles_container__3dBMt","title":"styles_title__1hplL","wrapper":"styles_wrapper__TV-Ih","answer":"styles_answer__3VH95"};